'use client';

import { useTransition } from 'react';
import dynamic from 'next/dynamic';
import { usePathname, useRouter } from '@/i18n/navigation';
import { getWanModel } from '@/lib/wan/catalog';
import type { GeneratorCategoryId } from '@/lib/wan/categories';
import { GeneratorSelectors } from './GeneratorSelectors';
import { resolveVersionModel, wanFamilyVersion, wanPageVersions, wanVersionHref } from '@/lib/wan/pages';

const WanGenerator = dynamic(() => import('@/components/wan/WanGenerator'));

export default function TypeGenerator({ categoryId, modelKey, version, title, description }: {
  categoryId: GeneratorCategoryId; modelKey: string; version?: string; title: string; description: string;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const [changing, startTransition] = useTransition();
  const renderSelectors = (disabled: boolean) => <GeneratorSelectors categoryId={categoryId} modelKey={modelKey} version={version} disabled={disabled || changing}
    onCategoryChange={id => startTransition(() => {
      if (version) {
        const selectedVersion = getWanModel(modelKey)?.version;
        const next = resolveVersionModel(version, selectedVersion ? `${selectedVersion}/${id === 'video-to-video' ? 'video-edit' : id === 'image-to-image' ? 'image-edit' : id}` : undefined, id);
        if (next) router.push(`${pathname}?model=${encodeURIComponent(next.key)}`, { scroll: false });
      } else router.push(`/${id}`);
    })}
    onModelChange={key => {
      const query = new URLSearchParams(window.location.search);
      query.set('model', key);
      const selectedModel = getWanModel(key);
      const selectedFamily = selectedModel && wanFamilyVersion(selectedModel.version);
      const nextPath = version
        ? selectedFamily && wanPageVersions.includes(selectedFamily) ? wanVersionHref(selectedFamily) : `/${categoryId}`
        : pathname;
      startTransition(() => router.replace(`${nextPath}${query.size ? `?${query}` : ''}`, { scroll: false }));
    }} />;
  return <WanGenerator model={getWanModel(modelKey)!} title={title} description={description} renderSelectors={renderSelectors} />;
}
